import React from 'react';

import { useEvent } from '@legacy-providers/event';

import { unclaimParkingSticker } from '@shared/parking-stickers/endpoints/unclaimParkingSticker';
import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { Modal, ModalContent, ModalContentActions } from '@shared/ui/components/Modal';
import { ModalTrigger } from '@shared/ui/components/Modal/ModalTrigger';

type ParkingRequestParkingSticker = App.Domain.Parking.Data.ParkingRequestParkingStickerData;

type Props = {
  parkingRequestParkingSticker: ParkingRequestParkingSticker;
  onUnclaim?: (parkingSticker: ParkingRequestParkingSticker) => void;
};

export function UnclaimParkingStickerButton({ parkingRequestParkingSticker, onUnclaim }: Props) {
  const event = useEvent();

  async function handleUnclaim() {
    await unclaimParkingSticker(event.id, parkingRequestParkingSticker);
    onUnclaim?.(parkingRequestParkingSticker);
  }

  if (!parkingRequestParkingSticker.claimedAt) {
    return null;
  }

  return (
    <Modal>
      <ModalTrigger asChild>
        <Button variant="destructive" size="sm">
          <Icon icon="undo" />
          Unclaim
        </Button>
      </ModalTrigger>
      <ModalContent title="Delete">
        <p>Are you sure you want to unclaim this sticker?</p>
        <ModalContentActions onConfirm={handleUnclaim} />
      </ModalContent>
    </Modal>
  );
}
